import { render } from "./CadastroListaDocumentoView.vue?vue&type=template&id=48a75931"
import script from "./CadastroListaDocumentoView.vue?vue&type=script&lang=js"
export * from "./CadastroListaDocumentoView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__